import stateClass, {CHANGE_EVENT} from '../baseState';

/*
* Selected pie chart sector (single) state
*/

class MessageStateClass extends stateClass{

	constructor(){

		super();

		this.data = '';
	}
}

var MessageState = new MessageStateClass;

export {MessageState, CHANGE_EVENT}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/messageBar/state.js